import { z } from 'zod';
import { CustomVizRequest } from 'libs/end-to-end/src/custom-viz/CustomVizRequest';
import { ObservationLocationType } from 'libs/end-to-end/src/observation-upload-type';

export const GenerateShareLinkRequest = z.object({
  baseUrl: z.string(),
  request: CustomVizRequest,
});

export type GenerateShareLinkRequest = z.infer<typeof GenerateShareLinkRequest>;

export const GenerateShareLinkResult = z.object({
  shareLink: z.string(),
});

export type GenerateShareLinkResult = z.infer<typeof GenerateShareLinkResult>;

export const ShareLinkData = z.object({
  organizationId: z.string(),
  observationLocationType: ObservationLocationType,
  payloadHash: z.string(),
});

export type ShareLinkData = z.infer<typeof ShareLinkData>;
